export default __webpack_public_path__ + "static/cho-spicer-2ef6fbb6c975c5d0d63e1cd3a96edf15.jpeg";